import { useThree, useFrame } from '@react-three/fiber';
import configs from 'configs';
import {
  DEFAULT_ROTATION_X_ANGLE,
  STEP_WIDTH,
  TOP_Y,
  TRANSFORM_RATIO,
} from 'containers/world/constant';
import {
  calcFootRotationY,
  calcScaleForProjection,
} from 'containers/world/utils';
import { useEffect, useRef } from 'react';
import { FrontSide, TextureLoader } from 'three';
import * as THREE from 'three';

const JumpSpot = ({ location }) => {
  const meshRef = useRef();
  const { camera } = useThree();
  const scaleRef = useRef({
    factor: 0,
    x: 1,
    y: 1,
  });
  const textureRef = useRef();

  useEffect(() => {
    const textureLoader = new TextureLoader();
    textureLoader.load(
      configs.baseUrl +
        '/assets/images/navigation/jumpspot-animation-arrow.png',
      (texture) => {
        texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
        texture.repeat.set(1 / 21, 1);
        textureRef.current = texture;
        if (meshRef.current?.material) {
          meshRef.current.material.map = texture;
          meshRef.current.material.needsUpdate = true;
        }
      }
    );
  }, [meshRef]);

  useEffect(() => {
    const [x, y, z] = location;
    const { scaleX, scaleY } = calcScaleForProjection(y);
    const angleRotate = calcFootRotationY(location);
    meshRef.current.visible = y <= TOP_Y;
    meshRef.current.position.set(
      TRANSFORM_RATIO * x,
      TRANSFORM_RATIO * y,
      TRANSFORM_RATIO * z
    );
    meshRef.current.scale.set(scaleX, scaleY);
    scaleRef.current.factor = 1;
    scaleRef.current.x = scaleX;
    scaleRef.current.y = scaleY;
    meshRef.current.rotation.set(DEFAULT_ROTATION_X_ANGLE, 0, angleRotate);
  }, [location, camera.position]);

  useFrame(({ clock }) => {
    if (textureRef.current) {
      const elapsed = clock.getElapsedTime();
      const frame = Math.floor((elapsed / 0.05) % 21);
      textureRef.current.offset.x = frame / 21;
    }
  });

  return (
    <mesh ref={meshRef}>
      <planeGeometry args={[STEP_WIDTH, STEP_WIDTH]} />
      <meshPhongMaterial
        color={'white'}
        alphaTest={0.5}
        side={FrontSide}
        transparent
        opacity={1.5}
      />
    </mesh>
  );
};

export default JumpSpot;
